import React from 'react';

import ContentfulImage from '../../Common/ContentfulImage';
import RichTextConverter from '../../Common/RichText/RichTextConverter';
import PageSection from '../../PageSections/PageSection';
import * as styles from './CustomerInFocus.module.scss';
import FocusAnimation from './FocusAnimation';

export default function CustomerInFocus({ section }) {
  return (
    <PageSection slim className={styles.section} data-analytics-section={'customer-in-focus'}>
      <div className={styles.content} data-analytics-component={'customer-in-focus-copy'}>
        <ContentfulImage imageFragment={section.mainImage} lazy={true} className={styles.image} />
        <div className={styles.superheading}>{section.subtitle}</div>
        <h2>{section.title}</h2>
        <RichTextConverter copy={section.copy} className={styles.copy} />
      </div>
      <div className={styles.animation} data-analytics-component={'customer-in-focus-animation'}>
        <FocusAnimation />
      </div>
    </PageSection>
  );
}
